import classnames from 'classnames';
import { forwardRef } from 'react';
import { FieldError } from 'react-hook-form';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: FieldError;
  subtitle?: string;
  isDirty?: boolean;
};

const Component = forwardRef<HTMLInputElement, Props>(
  ({ label, error, isDirty, subtitle, children, ...rest }, ref) => {
    return (
      <div>
        <fieldset className="flex w-full flex-col">
          <label>{label}</label>
          <div
            className={classnames(
              'mt-1 flex h-12 w-full rounded',
              {
                'border border-solid border-red-500': error,
                'border border-solid border-gray-300': !error && isDirty,
              },
              error || isDirty ? 'bg-white' : 'bg-gray-100',
            )}
          >
            <input
              ref={ref}
              className="w-full appearance-none bg-transparent pl-4 focus:outline-none focus-visible:outline-none"
              {...rest}
            />
            {children}
          </div>
          {subtitle && !error && (
            <div className="mt-1 text-xs text-gray-400">{subtitle}</div>
          )}
        </fieldset>
        {error && (
          <div className="mt-1.5 text-xs text-red-500">{error.message}</div>
        )}
      </div>
    );
  },
);

export default Component;
